<template>
  <div class="dialog-overlay" @click.stop>
    <div>
      <i-local-close class="close-btn" @click.stop="emits('confirm', false)" />
      <div class="bold">Thanks for asking your questions!</div>
      <div class="line2">Your chat history will be erased and you can start a new chat session.</div>
      <ChatbotButton style="width: 220px" @click="emits('confirm', true)">END CHAT</ChatbotButton>
      <ChatbotButton secondary style="width: 220px" @click="emits('confirm', false)">ASK MORE QUESTIONS</ChatbotButton>
    </div>
  </div>
</template>
<script setup lang="ts">
  const emits = defineEmits(['confirm'])
</script>

<style lang="scss" scoped>
  .bold {
    font-weight: 700;
  }
  .line2 {
    font-size: 12px;
    font-style: italic;
  }
  .dialog-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;

    font-family: 'Roboto', sans-serif;
    font-weight: 700;
    font-style: normal;
    // transition: 0.3s;
    color: #546e7a;
    > div {
      position: relative;
      width: 80%;
      background-color: #eceff1;
      border-radius: 15px;
      text-align: center;
      padding: 40px;
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      align-items: center;
      overflow: hidden;
    }
  }
  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    padding: 4px;
  }
</style>
